/**
 * 帮助函数.
 *
 * @author yusangeng@outlook.com
 */
import isNumber from "lodash/isNumber";
import isBoolean from "lodash/isBoolean";
import isUndefined from "lodash/isUndefined";
var isArray = Array.isArray;
/**
 * 帮助函数, 可以通过Konph.helper访问.
 *
 * @namespace
 */
var helper = {
    /**
     * 常用fit函数.
     *
     * @example
     * fit提供的方法常用来简化配置中fit函数的书写, 比如:
     *
     * {
     *   foobar: {
     *     def: true,
     *     fit: Konph.helper.fit.boolean // 将任何值转换为布尔值
     *   }
     * }
     *
     * @namespace
     */
    fit: {
        /**
         * 转换为布尔值.
         *
         * 字符串`false`和`0`会转换为false, 其他值转换为!!value.
         *
         * @param {any} value 输入值.
         * @returns {boolean} 转换结果.
         */
        boolean: function (value) {
            if (value === "false" || value === "0") {
                return false;
            }
            return !!value;
        },
        // 兼容老版本
        bool: function (value) {
            return helper.fit.boolean(value);
        },
        /**
         * 转换为数字类型.
         *
         * 如果是数字则直接返回, 如果是布尔值或可parseFloat的字符串会转换为number, 其余转换为NaN.
         *
         * @param {any} value 输入值.
         * @returns {number} 转换结果.
         */
        number: function (value) {
            if (typeof value === "string") {
                if (value === "true") {
                    return 1;
                }
                else if (value === "false") {
                    return 0;
                }
                var n = parseFloat(value);
                if (isNaN(n)) {
                    console.warn("".concat(value, " is NOT a number."));
                    return NaN;
                }
                return n;
            }
            if (isNumber(value)) {
                return value;
            }
            if (isBoolean(value)) {
                return value ? 1 : 0;
            }
            return NaN;
        },
        /**
         * 转换为字符串列表.
         *
         * 如果是数组直接返回, 如果是字符串, 执行以下操作:
         *   1. 首先trim.
         *   2. 去掉开头的`[`和结尾的`]`.
         *   3. 用`,`分割.
         *   4. 对分割的每一项trim.
         *   5. 删除为空字符串的项.
         *   6. 将得到的数组返回.
         *
         * 如果是undefined, 返回空数组, 如果是其他值, 则包装成一个数组返回.
         *
         * @param {any} value 输入值.
         * @returns {Array} 转换结果.
         */
        strings: function (value) {
            if (isArray(value)) {
                return value.map(function (el) { return "" + el; });
            }
            if (isUndefined(value)) {
                return [];
            }
            if (typeof value === "string") {
                var v = value.trim().replace(/^\[/, "").replace(/\]$/, "").trim();
                var ret = v
                    .split(",")
                    .map(function (el) { return el.trim(); })
                    .filter(function (el) { return el !== ""; });
                return ret;
            }
            return [value];
        },
        // 兼容老版本
        array: function (value) {
            return helper.fit.strings(value);
        }
    }
};
export default helper;
//# sourceMappingURL=data:application/json;base64,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